// import Swiper from "swiper";
import Splide from "@splidejs/splide";

const slider = function (next) {
	const sliderElements = next.querySelectorAll(".splide");
	const dottedLine = next.querySelector(".dotted-line");

	if (sliderElements.length < 2) return; // didn't find any, exiting...

	let leftSlider = new Splide(sliderElements[0], {
		type: "slide",
		direction: "ttb",
		pagination: true, 
		// paginationDirection: 'ttb',
		perPage: 4,
		drag: true,
		flickPower: 100,
		focus: "center",
		width: "100%",
		height: "calc(100vh)",
		speed: 300,
		arrows: false,
		classes: {
			pagination: 'splide__pagination slider-pagination', // Default is 'splide__pagination'.
			page      : 'splide__pagination__page slider-dot',
	  	},
		breakpoints: {
			1200: {
				perPage: 3,
				pagination: false,
				speed: 500,
			},
		},
	});

	leftSlider.on( 'pagination:mounted', function ( paginationItem ) {
		next.querySelectorAll(".slider-dot").forEach((item, index) => {
			item.addEventListener("click", function(e) {
				e.preventDefault();
				rightSlider.go(index);
			});
		});
	});
	
	// leftSlider.on('ready', function () {
	// 	next.querySelector("#splide01-slide01").classList.add('active');
	// });

	leftSlider.mount();

	
	leftSlider.on( 'move', function (index, prevIndex, destIndex, pagination) {
		leftSlider.Components.Slides.getAt(destIndex).slide.classList.remove('active');
		leftSlider.Components.Slides.getAt(prevIndex).slide.classList.remove('active');
		leftSlider.Components.Slides.getAt(index).slide.classList.add('active');
		rightSlider.go(index);
		leftSlider.go(index);
	});

	let rightSlider = new Splide(sliderElements[1], {
		type: "loop",
		direction: "ttb",
		width: "100%",
		height: "calc(100vh)",
		speed: 300,
		arrows: false,
		pagination: false,
		drag: false,
		breakpoints: {
			1024: {
				drag: false,
				speed: 500
			},
		},
	});

	rightSlider.mount();

	next.querySelectorAll(".year-card").forEach(item => {
		item.addEventListener("click", function(e) {
			e.preventDefault();
			leftSlider.go(parseInt(e.target.dataset.splideIndex));
			rightSlider.go(parseInt(e.target.dataset.splideIndex));
		});
	});


};

export default slider;
